import React, {
  useEffect,
  useRef,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import {
  FileInputModal,
  FileInputModalProps,
} from "src/components/file-input/FileInputModal";

type ImageContentInputProps = {
  editor: any;
};

export const ImageContentInput = forwardRef(
  (props: ImageContentInputProps, ref) => {
    const { editor } = props;
    const [paths, setPaths] = useState<string[]>([]);
    const fileInputModalRef = useRef<any>();

    const modalProps: FileInputModalProps = {
      multiple: true,
      path: "admin/media",
      fileTypes: ["jpg", "jpeg", "png", "gif", "svg", "webp"],
      paths: paths,
      setPaths: setPaths,
    };

    useEffect(() => {
      if (editor.current && paths.length > 0) {

        let tag = `<img src="${process.env.REACT_APP_AWS_CLOUDFRONT_URL}${paths[0]}" alt=""/>`;
        editor.current.execCommand("mceInsertContent", false, tag);
      }
    }, [paths]);

    function getMethods(obj) {
      var res = [];
      for (var m in obj) {
        res.push(m);
      }
      return res;
    }

    const openModal = () => {
      const currentRef = fileInputModalRef.current;
      if (currentRef) {
        currentRef.handleOpen();
      }
    };

    useImperativeHandle(
      ref,
      () => {
        return {
          open() {
            openModal();
          },
        };
      },
      []
    );

    return (
      <FileInputModal ref={fileInputModalRef} {...modalProps}></FileInputModal>
    );
  }
);
